import { signal } from 'services/SignalsService'

import TimeStage from './TimeStage'

export default class EndStage extends TimeStage {
  constructor(data, id){
    super(data, id)
  }

  start(position, time) {
    super.start(position, time)
    signal.dispatch('START-STOP-ANIMATION', this.reelID)
  }

  completeCalculation(time){
    super.completeCalculation(time)
    signal.dispatch('END-STOP-REEL', this.reelID)
  }
}
